import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Box, Checkbox, FormHelperText, FormLabel } from "@material-ui/core";
import classnames from "classnames";

import { SubTitle, useFieldsStyles } from "../fields.styles";

import { CheckboxFieldProps } from "./checkbox-field.props";

export const CheckboxField = (props: CheckboxFieldProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(Boolean(props.form.getValues(props.name)));
  const commonClasses = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);

  const wrapperClasses = classnames({
    [commonClasses.fieldWrapper]: true,
    [commonClasses.hidden]: props.hidden,
  });

  const handleChange = (event: any) => {
    const checked = event.target.checked;
    setIsChecked(checked);

    if (!checked) {
      React.Children.forEach(props.children, (child) => {
        const resetValue = Boolean(child.props.options) ? [] : "";
        props.form.setValue(child.props.name, resetValue);
      });
    }
  };

  const childrenWithNewProps = React.Children.map(props.children, (child, index) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        // @ts-ignore
        disabled: !isChecked,
        withAdd: false,
        childIndex: index,
      });
    } else {
      return child;
    }
  });

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <div className={wrapperClasses}>
          <Box display="flex" justifyContent="space-between">
            <SubTitle showIf={!!props.subTitle}>{props.subTitle}</SubTitle>
            <FormLabel htmlFor={props.name} error={hasError} required={props.required}>
              <Checkbox
                {...{ ...renderProps.field, ref: undefined }}
                checked={renderProps.field.value}
                checkedIcon={props.iconChecked}
                disabled={!canEdit}
                icon={props.icon}
                id={props.name}
                inputRef={renderProps.field.ref}
                onChange={(event) => {
                  renderProps.field.onChange(event);
                  handleChange(event);
                }}
              />
              {props.label}
            </FormLabel>
          </Box>

          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}

          {childrenWithNewProps}
        </div>
      )}
    />
  );
};
